module.exports = __webpack_public_path__ + "img/close-up-gevulde-donut-bakvormen.2b89c780.jpg";